



















import { defineComponent, ref, onMounted, onUnmounted } from '@nuxtjs/composition-api'
import NavigationList from './NavigationList.vue'

export default defineComponent({
  components: { NavigationList },
  setup() {
    const isMenuVisible = ref(false)

    const toggleMenuVisibility = () => {
      isMenuVisible.value = !isMenuVisible.value
    }
    const hideMobileMenu = () => {
      isMenuVisible.value = false
    }

    onMounted(() => {
      window.addEventListener('resize', hideMobileMenu)
    })
    onUnmounted(() => {
      window.removeEventListener('resize', hideMobileMenu)
    })
    return { toggleMenuVisibility, isMenuVisible, hideMobileMenu }
  },
})
